import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

const QuickContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    email: "",
    mensaje: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.nombre || !formData.email || !formData.mensaje) {
      toast({
        title: "Campos incompletos",
        description: "Por favor completa nombre, email y mensaje.",
        variant: "destructive",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      await supabase.from("contact_submissions" as any).insert({
        nombre: formData.nombre,
        email: formData.email,
        empresa: formData.telefono || null,
        mensaje: `${formData.telefono ? `Tel: ${formData.telefono} - ` : ""}${formData.mensaje}`,
        source: "quick_contact",
      });
      
      toast({
        title: "¡Mensaje enviado! 🎉",
        description: "Te contactaremos en menos de 24 horas.",
      });
      
      setFormData({
        nombre: "",
        telefono: "",
        email: "",
        mensaje: "",
      });
    } catch (err) {
      console.error("Error saving contact:", err);
      toast({
        title: "Error",
        description: "No se pudo enviar. Inténtalo de nuevo.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 w-full">
      <Input
        type="text"
        name="nombre"
        placeholder="Tu nombre"
        value={formData.nombre}
        onChange={handleChange}
        required
        className="h-14 text-lg"
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          type="email"
          name="email"
          placeholder="tu@email.com"
          value={formData.email}
          onChange={handleChange}
          required
          className="h-14 text-lg"
        />
        
        <Input
          type="tel"
          name="telefono"
          placeholder="Teléfono (opcional)"
          value={formData.telefono}
          onChange={handleChange}
          className="h-14 text-lg"
        />
      </div>
      
      <Textarea
        name="mensaje"
        placeholder="Ej: Quiero automatizar la atención telefónica de mi clínica"
        value={formData.mensaje}
        onChange={handleChange}
        required
        className="min-h-[120px] resize-none text-lg"
      />
      
      <Button 
        type="submit" 
        size="lg" 
        disabled={isSubmitting}
        className="w-full h-14 text-lg font-light rounded-xl bg-foreground text-background hover:bg-foreground/90 transition-all"
      >
        {isSubmitting ? "Enviando..." : "Enviar mensaje"}
      </Button>

      <p className="text-center text-sm text-muted-foreground">
        Sin compromiso. Te contactamos en menos de 24h.
      </p>
    </form>
  );
};

export default QuickContactForm;
